<body>

    <div class="purchase-info-container" *ngIf="!this.contract.status.includes('INVESTIGATED'); else bpoAnalysis">
        <div class="sucess-logo"
            *ngIf=" this.contract.paymentMethod.identifier !== 'PIX' || this.isPixPaid && this.pixData.chargedUser">
            <img src="../../../../assets/images/feather-icons/OrderSuccess.svg">
        </div>
        <p *ngIf="contract.paymentMethod.identifier !== 'PIX' || (this.isPixPaid && this.pixData.chargedUser)"
            class="order-code">Pedido {{contract.code}}</p>
        <p *ngIf="contract.paymentMethod.identifier !== 'PIX'" class="order-sucess">Pedido efetuado com sucesso!</p>
        <p *ngIf="finalBalanceTrust && contract.paymentMethod.identifier !== 'PIX'" class="finalBalanceTrust">
            <b>{{finalBalanceTrust | currency: 'R$'}}</b> serão adicionado ao seus créditos.<br>Você já pode usufruir o
            produto adquirido, basta clicar no botão abaixo:</p>
        <!-- Cartão de crédito -->
        <div *ngIf="this.contract.paymentMethod.identifier === 'CREDIT_CARD' && !this.contract.trialData"
            class="credit-card">
            <p id="purchase-info"
                *ngIf="contract.product.classificationIdentifier === 'consulta-e-recuperacao-de-dividas' && !finalBalanceTrust">
                <b>R$ {{ invoiceSubtotal }} </b>serão adicionados ao seus créditos.
            </p>
            <span *ngIf="classificationIdentifier === 'plano-mensal' || classificationIdentifier === 'plano-mensal-recarga-pontual'
                         || classificationIdentifier === 'consulta-e-recuperacao-de-dividas'">
                <b>Lembre-se:</b>

                <ng-container *ngIf="balanceExpirationDate === 99; else expirationByDays">
                    Seu crédito tem validade <b> durante o período de cada renovação.</b>
                </ng-container>
                <ng-template #expirationByDays>
                    Seu crédito tem validade de <b>{{ balanceExpirationDate }} dias a partir da data da compra.</b>
                </ng-template>
            </span>
            <p id="purchase-info"
                *ngIf="contract.product.classificationIdentifier != 'consulta-e-recuperacao-de-dividas' && !finalBalanceTrust">
                Você já pode
                usufruir o produto adquirido, basta clicar no botão abaixo:</p>


            <div class="button-holder"
                *ngIf="!contract.provisioningParameters.allowAutomaticRecharge || (contract.product.classificationIdentifier === 'consulta-e-recuperacao-de-dividas' && contract.provisioningParameters.allowAutomaticRecharge)">
                <button mat-flat-button color="primary" (click)="onSuccessButtonClick.emit()">Acessar produtos</button>
            </div>

            <div class="info-message-text">
                <pme-info-message type="new-info" [title]="'Atenção!'">
                    <p>Sua nota fiscal será enviada dentro de <strong>5 dias úteis</strong>.</p>
                </pme-info-message>
            </div>
            <!-- <div class="pme-alert-padding">
                <pme-alert type="info" title="Atenção">
                    <p>Sua <strong>nota fiscal</strong> será enviada dentro de <strong>5 dias úteis</strong>.</p>
                </pme-alert>
            </div> -->
        </div>

        <!-- Boleto bancário -->
        <div *ngIf="this.contract.paymentMethod.identifier === 'BANK_BILLET'">
            <div *ngIf="bankBilletData.barcode" class="bank-billet">
                <!-- <div>
            <div> -->
                <p id="purchase-info" class="info-payment">Realize o pagamento com a linha digitável abaixo ou clique
                    para baixar o boleto.
                </p>

                <br>
                <div class="info-message-text ">
                    <pme-info-message type="new-info" [title]="'Atenção!'">
                        <p>Sua nota fiscal será enviada dentro de <strong>5 dias úteis</strong>.</p>
                    </pme-info-message>
                </div>



                <div class="billet-info">
                    <div class="info-bar-code">
                        <p id="remember">Copia e cola:</p>
                    </div>
                    <div class="data-bar-code">
                        <mat-card>
                            <mat-card-content>
                                <b>{{this.bankBilletData.barcode}}</b>
                                <img class="icon-copy" src="/assets/images/icon-copy.svg" matTooltip="Copiar código"
                                    (click)="copyContent()">
                            </mat-card-content>
                        </mat-card>
                    </div>


                    <!-- <div class="info-message-text remember-message">
                        <pme-info-message type="info" [title]="'Lembre-se:'">
                            <p>{{this.bankBilletData.remember}}</p>
                        </pme-info-message>
                    </div> -->
                    <div class="pme-alert-padding">
                        <pme-alert type="info" title="Lembre-se!">
                            {{this.bankBilletData.remember}}
                        </pme-alert>
                    </div>




                </div>
                <div class="buttons">

                    <button mat-flat-button (click)="openBankBilletOnNewTab(this.bankBilletData.bankBilletURL)">Baixar
                        boleto<mat-icon>arrow_downward</mat-icon></button>
                    <div class="button-holder"
                        *ngIf="!contract.provisioningParameters.allowAutomaticRecharge || (contract.product.classificationIdentifier === 'consulta-e-recuperacao-de-dividas' && contract.provisioningParameters.allowAutomaticRecharge)">
                        <button mat-flat-button color="primary" (click)="onSuccessButtonClick.emit()">Acessar
                            produtos</button>
                    </div>
                </div>
            </div>

            <!-- Tela de boleto bancário qnd vem sem os dados do boleto -->
            <div *ngIf="!bankBilletData.barcode" class="bank-billet">
                <p id="purchase-info">{{bankBilletData.totalValue.valueOf() > 0 ? "Você receberá o boleto e" : "Você
                    receberá"}} as informações relativas a compra no email.</p>

                <button id="width-100" mat-flat-button color="primary" (click)="onSuccessButtonClick.emit()">Acessar
                    produtos
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>
        </div>

        <!-- PIX -->
        <div *ngIf="this.contract.paymentMethod.identifier === 'PIX'" class="pix">

            <!-- SUCESSO INICIAL -->
            <div class="payment-method-container"
                *ngIf="this.pixData.chargedUser && !this.timeExpired && !this.isPixPaid">
                <div class="title-payment-method-container">
                    <b id="font-size-24" *ngIf="!this.paymentInitiationId">Estamos quase lá!</b>
                    <p id="purchase-info-pix" *ngIf="!this.paymentInitiationId">Falta pouco para ter acesso ao seu novo
                        produto!</p>
                </div>
                <div *ngIf="!isPixPaid" class="content-time">
                    <img class="icon-timer" src="/assets/images/icon-timer.svg" />
                    <p>
                        Esse código expira em
                        <b>
                            <pme-timer-formatter [seconds]="this.expirationTime" (onTimerComplete)="changePage()"
                                (onStart)="pixPaid()">
                            </pme-timer-formatter>
                        </b>
                        minutos
                    </p>
                </div>
                <div class="pix-info">
                    <!-- imagem -->
                    <div class="data-bar-qr-code">
                        <mat-card>
                            <img src="data:image/png;base64,{{this.pixData.file}}">
                        </mat-card>
                    </div>

                    <!-- copia e cola -->
                    <div class="data-bar-code">
                        <div class="copia-e-cola">
                            <p id="p"> Copia e cola:</p>
                        </div>


                        <mat-card>
                            <b id="b">{{this.pixData.qrCode}}</b>
                            <div class="img-icon">
                                <img class="icon-copy" src="/assets/images/icon-copy.svg" matTooltip="Copiar código"
                                    (click)="copyPixContent()">
                            </div>
                        </mat-card>
                    </div>
                </div>
            </div>

            <!-- PIX EXPIRADO -->
            <div
                *ngIf="(this.pixData.chargedUser && this.timeExpired) || (this.pixData.chargedUser && this.timeExpired )">

                <div class="pix-expired-header">
                    <div class="expired-warn-icon">
                        <img src="/assets/images/expired-warn.svg">
                    </div>
                    <div class="expired-title">
                        <p id="expired">Código para pagamento expirou.</p>
                    </div>
                </div>

                <div class="pix-expired-text">
                    <p id="font-size-14-pix">
                        Para realizar o pagamento, gere um novo código Pix.
                    </p>
                </div>

                <div class="buttons">
                    <button mat-flat-button color="success" type="submit" [disabled]="submitting"
                        (click)=getPix2ndCopy()>
                        <div class="display-utils-row display-utils-center-center display-utils-gap-8">
                            <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                            <div>Gerar novo código</div>
                        </div>
                    </button>
                </div>

                <!-- importante -->
                <div class="pme-alert-padding">
                    <pme-alert type="info" title="Importante!">
                        Se o pagamento não for confirmado em até 2 dias úteis, o pedido será cancelado automaticamente.
                    </pme-alert>
                </div>
            </div>

            <!-- PIX PAGO -->
            <div *ngIf="this.pixData.chargedUser && this.isPixPaid">
                <div>
                    <p class="order-sucess ">Pedido efetuado com sucesso!</p>
                    <p id="font-size-14" *ngIf="contract.product.classificationIdentifier === 'plano-mensal'">
                        <span>

                            <b> {{(finalBalanceTrust ? finalBalanceTrust : calculateFinalValue()) | currency: 'R$'}}</b>
                            serão adicionados ao seus créditos.
                        </span>
                    </p>
                    <span *ngIf="classificationIdentifier === 'plano-mensal' || classificationIdentifier === 'plano-mensal-recarga-pontual'
                         || classificationIdentifier === 'consulta-e-recuperacao-de-dividas'">
                        <b>Lembre-se:</b>

                        <ng-container *ngIf="balanceExpirationDate === 99; else expirationByDays">
                            Seu crédito tem validade <b> durante o período de cada renovação.</b>
                        </ng-container>
                        <ng-template #expirationByDays>
                            Seu crédito tem validade de <b>{{ balanceExpirationDate }} dias a partir da data da
                                compra.</b>
                        </ng-template>
                    </span>
                    <p class="purchase-added-text" *ngIf="contract.product.classificationIdentifier !== 'plano-mensal'">
                        <span>
                            <b>{{(finalBalanceTrust ? finalBalanceTrust : calculateFinalValue()) | currency: 'R$'}}</b>
                            serão adicionados ao seus créditos.
                        </span>
                        <span>
                            Você já pode usufruir do produto adquirido, basta clicar no botão abaixo:
                        </span>
                    </p>

                    <br>
                    <div class="button-holder"
                        *ngIf="!contract.provisioningParameters.allowAutomaticRecharge || (contract.product.classificationIdentifier === 'consulta-e-recuperacao-de-dividas' && contract.provisioningParameters.allowAutomaticRecharge)">
                        <button mat-flat-button color="primary" (click)="onSuccessButtonClick.emit()">Acessar
                            produtos</button>
                    </div>
                    <div class="info-message-text info-atention">
                        <pme-info-message type="new-info" [title]="'Atenção!'">
                            <p>Sua nota fiscal será enviada dentro de <strong>5 dias úteis</strong>.</p>
                        </pme-info-message>
                    </div>

                    <br>

                </div>
            </div>
            <!-- Tela de pix qnd vem sem os dados de pix -->
            <div
                *ngIf="!this.pixData.chargedUser && this.contract.status !== 'ACTIVE' &&  this.contract.status !== 'PAID'">
                <div class="sucess-logo">
                    <img src="../../../../assets/images/feather-icons/OrderSuccess.svg">
                </div>
                <p id="purchase-info">Você receberá as chaves do pix e as informações relativas à compra no email.
                </p>

                <button id="width-100" color="primary" mat-flat-button (click)="onSuccessButtonClick.emit()">Acessar
                    produtos
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>

            <!-- Tela de pix qnd ocorre fatura mínima -->
            <div
                *ngIf="!this.pixData.chargedUser && (this.contract.status === 'ACTIVE' || this.contract.status === 'PAID')">
                <div class="sucess-logo">
                    <img src="../../../../assets/images/feather-icons/OrderSuccess.svg">
                </div>
                <p class="order-code">Pedido {{contract.code}}</p>
                <p class="order-sucess ">Pedido efetuado com sucesso!</p>
                <p class="purchase-added-text" id="font-size-14"
                    *ngIf="contract.product.classificationIdentifier === 'plano-mensal'">
                    <span>
                        <b>{{(finalBalanceTrust ? finalBalanceTrust : calculateFinalValue()) | currency: 'R$'}}</b>
                        serão adicionados ao seus créditos.
                    </span>
                </p>
                <span *ngIf="classificationIdentifier === 'plano-mensal' || classificationIdentifier === 'plano-mensal-recarga-pontual'
                         || classificationIdentifier === 'consulta-e-recuperacao-de-dividas'">
                    <b>Lembre-se:</b>

                    <ng-container *ngIf="balanceExpirationDate === 99; else expirationByDays">
                        Seu crédito tem validade <b> durante o período de cada renovação.</b>
                    </ng-container>
                    <ng-template #expirationByDays>
                        Seu crédito tem validade de <b>{{ balanceExpirationDate }} dias a partir da data da compra.</b>
                    </ng-template>
                </span>
                <p class="purchase-added-text" *ngIf="contract.product.classificationIdentifier !== 'plano-mensal'">
                    <span>
                        <b>{{(finalBalanceTrust ? finalBalanceTrust : calculateFinalValue()) | currency: 'R$'}}</b>
                        serão adicionados ao seus
                        créditos.
                    </span>
                    <span>
                        Você já pode usufruir do produto adquirido, basta clicar no botão abaixo:
                    </span>
                </p>

                <br>

                <p id="purchase-info">Você receberá as informações relativas à compra no email.
                </p>

                <button id="width-100" color="primary" mat-flat-button (click)="onSuccessButtonClick.emit()">Acessar
                    produtos
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>


        </div>

        <div *ngIf="this.contract.trialData">
            <p id="purchase-info"
                *ngIf="contract.product.classificationIdentifier != 'consulta-e-recuperacao-de-dividas'">Você já
                pode
                usufruir do produto adquirido, basta clicar no botão abaixo:
            </p>

            <div style="display: grid;">
                <div class="delayDate">
                    <b>Fim do período de teste:</b>
                    <span class="date">{{this.endDate}}</span>
                </div>

                <div class="delayDate">
                    <b>Início da vigência:</b>
                    <span class="date">{{this.contract.trialData.trialEndDate}}</span>
                </div>
            </div>



            <div class="trialMessage">
                <mat-card>
                    <mat-card-content>
                        <p><b>Atenção:</b> após o fim do período de teste grátis, no dia {{this.endDate}}, será debitado
                            {{this.installment}}X de R$ {{this.calculeInstallmentValue()}} no seu cartão
                            cadastrado.</p>
                        <br>
                        <p>
                            A menos que você cancele antes do final do período de testes, a cobrança será feita conforme
                            a forma de pagamento selecionada previamente.
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>

            <div *ngIf="!contract.provisioningParameters.allowAutomaticRecharge">
                <button mat-flat-button color="primary" (click)="onSuccessButtonClick.emit()">Acessar
                    produtos<mat-icon>arrow_forward
                    </mat-icon></button>
            </div>
        </div>
    </div>

    <ng-template #bpoAnalysis>
        <p id="font-size-16">Confirmação de compra</p>
        <p id="font-size-24">Estamos quase lá!</p>

        <div class="bpo-analysis">
            <p id="purchase-info">Falta pouco para ter acesso ao seu novo crédito!</p>
            <b>Recebemos seu pedido e logo confirmaremos sua compra!</b>

            <mat-card>
                <mat-card-content>
                    <p>Para maior segurança, alguns pedidos passam por um processo de confirmação de dados, mas não se
                        preocupe, o prazo máximo para conclusão é de até 6 horas.</p>
                    <br>
                    <p>Te avisaremos por e-mail assim que o status for atualizado :)</p>
                </mat-card-content>

            </mat-card>

            <p id="font-size-12">
                * Em casos excepcionais, pode haver a necessidade de um tempo maior para a conclusão do processo de
                confirmação de dados.
            </p>
            <button id="width-100" mat-flat-button color="primary" (click)="onSuccessButtonClick.emit()">Acessar
                produtos
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </div>

    </ng-template>

</body>